// Essential for all components
import React, { Component } from 'react';
// import PropTypes from 'prop-types';
// import { Redirect } from 'react-router';
// import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";

// Styling

// Api
import { apiHistory } from '../../Api/ApiHistory';
import { apiWebPage } from '../../Api/ApiWebPage';

// Redux
import { connect } from 'react-redux';
import { login } from '../../Redux/Action/authAction';

// Utils
import { filter, get } from 'lodash-es';
import { createMarkup } from '../../utils/CommonUtils';

// Children components
import BreadCrumb from '../../components/100Include/BreadCrumb';

class OurMissionAndStrategy extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formSubmitted: false,
            contentUpper: null,
            contentContent: null,
            language: null,
            loading: false
        }
    }


    componentDidMount() {
        this.updateHtml();
        apiHistory.createHistory(window.location.pathname);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { language, loading } = this.state;
        if (!loading && (!language || language !== get(this, 'props.i18n.language'))) {
            this.updateHtml();
        }
    }

    updateHtml() {
        this.setState({
            loading: true,
            language: get(this, 'props.i18n.language')
        });
        apiWebPage.getPageData('/our-mission-and-strategy', (result) => {
            const language = get(this, 'props.i18n.language');
            const newState = {
                loading: false,
                language
            };
            const body = get(result, 'body');
            if (body && body.length > 0) {
                const attr = language && language.toLowerCase() === 'en-us' ? 'html_en' : 'html_zh_cht';

                const uppers = filter(body, ['section', 'upper']);
                if (uppers && uppers.length > 0) {
                    newState.contentUpper = uppers[0][attr];
                } else {
                    console.log('no upper section');
                }

                const contents = filter(body, ['section', 'content']);
                if (contents && contents.length > 0) {
                    newState.contentContent = contents[0][attr];
                } else {
                    console.log('no content section');
                }
            }
            this.setState(newState);
        });
    }

    render() {
        const { t } = this.props;

        return (
            <div className="wrapper-container-main">
                <Helmet>
                    <title>{t("Meta:ourMissionAndStrategy.title")}</title>
                    <meta name="description" content={t("Meta:ourMissionAndStrategy.description")} />
                </Helmet>
                <div className="container-main">
                    <BreadCrumb />
                    <div className="wrapper-content">
                        <div className="content">
                            <div className="ImageText">
                                <div className="upper">
                                    {/* <img src={require('../../images/AboutUs/banner_boutus-02Our-mission.png')} alt="" /> */}
                                    <div dangerouslySetInnerHTML={createMarkup(this.state.contentUpper)} />
                                </div>
                                <div className="bottom mission" style={{ textAlign: 'center' }}>
                                    <div>
                                        {/* <h3>{t("AboutUs:ourMissionAndStrategy.title")}</h3>
                                        <ul style={{
                                            listStylePosition: 'inside'
                                        }}>
                                            <li>{t("AboutUs:ourMissionAndStrategy.content1")}</li>
                                            <li>{t("AboutUs:ourMissionAndStrategy.content2")}</li>
                                            <li>{t("AboutUs:ourMissionAndStrategy.content3")}</li>
                                        </ul> */}
                                        <div dangerouslySetInnerHTML={createMarkup(this.state.contentContent)} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth
});

const mapDispatchToProps = dispatch => ({
    loginP: data => dispatch(login(data))
});

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(OurMissionAndStrategy));
